import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { useEffect } from 'react';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useNavigate } from 'react-router';
import { getInvestmentDetails } from '../../store/actions/fund-investment-action';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { TextWeight, isArabic, direction } = dynamicfunction();
  const { investmentContent } = useSelector((state) => state.content);
  const { investment_details, investment_loading } = useSelector((state) => state.fundInvestment);

  useEffect(() => {
    dispatch(getInvestmentDetails());
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      investmentContent?.web_investment_manage_investment?.data?.attributes,
      key,
      isArabic
    );
  };

  return {
    getContentKey,
    TextWeight,
    direction,
    navigate,
    investment_loading,
    investment_details,
    isArabic
  };
};
